import api from './api';

const vendorDashboardService = {
  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await api.get('/vendor-dashboard/stats');
    return response.data;
  },

  // Get vendor tasks with filtering
  getTasks: async (params = {}) => {
    const response = await api.get('/vendor-dashboard/tasks', { params });
    return response.data;
  },

  // Get vendor issues with filtering
  getIssues: async (params = {}) => {
    const response = await api.get('/vendor-dashboard/issues', { params });
    return response.data;
  },

  // Get co-vendors
  getCoVendors: async (params = {}) => {
    const response = await api.get('/vendor-dashboard/co-vendors', { params });
    return response.data;
  },

  // Create co-vendor
  createCoVendor: async (coVendorData) => {
    const response = await api.post('/vendor-dashboard/co-vendors', coVendorData);
    return response.data;
  },

  // Get vendor projects
  getProjects: async (params = {}) => {
    const response = await api.get('/vendor-dashboard/projects', { params });
    return response.data;
  },

  // Update task status
  updateTaskStatus: async (taskId, status) => {
    const response = await api.patch(`/vendor-dashboard/tasks/${taskId}/status`, { status });
    return response.data;
  },

  // Update issue status
  updateIssueStatus: async (issueId, status) => {
    const response = await api.patch(`/vendor-dashboard/issues/${issueId}/status`, { status });
    return response.data;
  },

  // Create new issue
  createIssue: async (issueData) => {
    const response = await api.post('/vendor-dashboard/issues', issueData);
    return response.data;
  },

  // Update issue (full update)
  updateIssue: async (issueId, issueData) => {
    const response = await api.put(`/vendor-dashboard/issues/${issueId}`, issueData);
    return response.data;
  },

  // Get recent activity
  getActivity: async (limit = 20) => {
    const response = await api.get('/vendor-dashboard/activity', { params: { limit } });
    return response.data;
  },

  createContract: async (vendor_id, data) => {
    const response = await api.post(`/vendors/${vendor_id}/contracts`, data);
    return response.data;
  },

  createVendorEmp: async (data) => {
    const response = await api.post(`/vendor-dashboard/createVendorEmp`, data);
    return response.data;
  },

  updateContract: async (vendor_id, row_id, data) => {
    const response = await api.put(`/vendors/${vendor_id}/contracts/${row_id}`, data);
    return response.data;
  },

  getContracts: async (vendor_id) => {
    const response = await api.get(`/vendors/${vendor_id}/contracts`);
    console.log("respoooo", response.data)
    return response.data;
  },

  getVendorContracts: async (params = {}) => {
    const response = await api.get(`/vendor-dashboard/contracts`, { params });
    console.log("respoooo", response.data)
    return response.data;
  },

  getVendorStats: async (limit = 20) => {
    const response = await api.get(`/vendor-dashboard/stats`, { params: { limit } });
    console.log("respoooo", response.data)
    return response.data;
  },

   getAllUsers: async (params = {}) => {
    try {
      const response = await api.get('/vendor-dashboard/users', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },


   getAllTimeTrackingApprovals: async (params = {}) => {
    try {
      const response = await api.get('/vendor-dashboard/time-tracking-submissions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

   getAllAssignedUsers: async (project_id,params = {}) => {
    try {
      const response = await api.get(`/vendor-dashboard/projects/${project_id}/allocated-resources`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

   submitTimetrackings: async (data) => {
    const response = await api.post(`/vendor-dashboard/time-tracking-approvals`, data);
    return response.data;
  },

};

export default vendorDashboardService;

